/**
 * @generated SignedSource<<42b4038899a7e4aecafa79d0f7fca5ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type UserRole = "CLIENT" | "COACH" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type GroupMemberBadges_user$data = {
  readonly role: UserRole;
  readonly " $fragmentType": "GroupMemberBadges_user";
};
export type GroupMemberBadges_user$key = {
  readonly " $data"?: GroupMemberBadges_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"GroupMemberBadges_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GroupMemberBadges_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "29621c6b300b6f7250ca40744ea6c08a";

export default node;
